import React, { useEffect } from 'react';
import Banner from '@atlaskit/banner';
import WarningIcon from '@atlaskit/icon/glyph/warning';

import { ColumnFullWidth } from '../styles';

type BannerProps = {
    isLicenseValid: boolean;
    children: JSX.Element,
}

const LicenseBannerStretcher = () => {

    useEffect(() => {
        const bannerColumn = document.getElementById('licenseColumn');
        // @ts-ignore
        const banner = bannerColumn.firstChild;
        // @ts-ignore
        banner.style['max-height'] = '52px';
    }, []);

    return null;
};


export const LicenseBanner = (props: BannerProps) => props.isLicenseValid
    ? <div>{props.children}</div>
    : (
        <>
            <ColumnFullWidth id='licenseColumn'>
                <Banner
                    appearance={'warning'}
                    icon={<WarningIcon label='Warning icon' secondaryColor='inherit' />}
                >
                    <span>No valid license.</span>
                </Banner>
                <LicenseBannerStretcher />
            </ColumnFullWidth>
            <div>
                {props.children}
            </div>
        </>
    );
